import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center gap-y-8 max-w-2xl mx-auto text-center" }

import { computed } from "vue";
import Tag from "./shared/tag/TagComponent.vue";
import Title from "./shared/title/TitleComponent.vue";
import Paragraph from "./shared/paragraph/ParagraphComponent.vue";
import Buttons from "./shared/buttons/ButtonsComponent.vue";
import PrimaryButton from "@/views/blocks/shared/section/buttons/primary-button/PrimaryButton.vue";
import SecondaryButton from "@/views/blocks/shared/section/buttons/secondary-button/SecondaryButton.vue";
import Section from "@/views/blocks/shared/section/layout/section/Section.vue";
import FullSpacing from "@/views/blocks/shared/section/layout/spacing/FullSpacing.vue";
import type { SimpleCenteredProps } from "./hero.interfaces";
import DetailComponent from "./shared/details/DetailComponent.vue";
import DetailsComponent from "./shared/details/DetailsComponent.vue";
import EditableElement from "@/views/page/EditableElement.vue";
import type { PageBlock } from "@/views/blocks/PageBlock.interface";
import { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import SocialProofComponent from "./shared/socialproof/SocialProofComopnent.vue";
import type { ScrollAnimationType } from "@/apps/page/page-project.interface";


export default /*@__PURE__*/_defineComponent({
  __name: 'SimpleCentered',
  props: {
    block: {},
    pageColors: {},
    scrollAnimationType: {}
  },
  setup(__props: any) {

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Section, {
    id: _ctx.block.webId,
    backgroundColor: styleValues.value.background,
    scrollAnimationType: _ctx.scrollAnimationType
  }, {
    default: _withCtx(() => [
      _createVNode(FullSpacing, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!dataValues.value.tag.isHidden)
              ? (_openBlock(), _createBlock(EditableElement, {
                  key: 0,
                  blockId: _ctx.block.id,
                  "field-name": "tag"
                }, {
                  default: _withCtx(() => [
                    _createVNode(Tag, _mergeProps(dataValues.value.tag.data, {
                      buttonTextColor: styleValues.value.brand,
                      textColor: styleValues.value.text,
                      borderColor: styleValues.value.border
                    }), null, 16, ["buttonTextColor", "textColor", "borderColor"])
                  ]),
                  _: 1
                }, 8, ["blockId"]))
              : _createCommentVNode("", true),
            (
                        !dataValues.value.socialProofText.isHidden ||
                        dataValues.value.socialProofImages.data.items.length > 0
                    )
              ? (_openBlock(), _createBlock(SocialProofComponent, {
                  key: 1,
                  blockId: _ctx.block.id,
                  socialProofText: dataValues.value.socialProofText,
                  socialProofImages: dataValues.value.socialProofImages.data,
                  borderColor: styleValues.value.background,
                  textColor: styleValues.value.text
                }, null, 8, ["blockId", "socialProofText", "socialProofImages", "borderColor", "textColor"]))
              : _createCommentVNode("", true),
            (!dataValues.value.title.isHidden)
              ? (_openBlock(), _createBlock(EditableElement, {
                  key: 2,
                  blockId: _ctx.block.id,
                  "field-name": "title"
                }, {
                  default: _withCtx(() => [
                    _createVNode(Title, _mergeProps(dataValues.value.title.data, {
                      textColor: styleValues.value.text
                    }), null, 16, ["textColor"])
                  ]),
                  _: 1
                }, 8, ["blockId"]))
              : _createCommentVNode("", true),
            (!dataValues.value.paragraph.isHidden)
              ? (_openBlock(), _createBlock(EditableElement, {
                  key: 3,
                  blockId: _ctx.block.id,
                  "field-name": "paragraph"
                }, {
                  default: _withCtx(() => [
                    _createVNode(Paragraph, _mergeProps(dataValues.value.paragraph.data, {
                      textColor: styleValues.value.text
                    }), null, 16, ["textColor"])
                  ]),
                  _: 1
                }, 8, ["blockId"]))
              : _createCommentVNode("", true),
            (dataValues.value.details.data.items.length > 0)
              ? (_openBlock(), _createBlock(DetailsComponent, {
                  key: 4,
                  textColor: styleValues.value.text
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataValues.value.details.data.items, (detail, index) => {
                      return (_openBlock(), _createBlock(EditableElement, {
                        key: detail.id,
                        blockId: _ctx.block.id,
                        "field-name": `details_${detail.id}`,
                        hideable: false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(DetailComponent, {
                            title: detail.title,
                            description: detail.description,
                            "is-last": index === dataValues.value.details.data.items.length - 1,
                            textColor: styleValues.value.text
                          }, null, 8, ["title", "description", "is-last", "textColor"])
                        ]),
                        _: 2
                      }, 1032, ["blockId", "field-name"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["textColor"]))
              : _createCommentVNode("", true),
            (
                        !dataValues.value.primaryButton.isHidden || !dataValues.value.secondaryButton.isHidden
                    )
              ? (_openBlock(), _createBlock(Buttons, { key: 5 }, {
                  default: _withCtx(() => [
                    (!dataValues.value.primaryButton.isHidden)
                      ? (_openBlock(), _createBlock(EditableElement, {
                          key: 0,
                          blockId: _ctx.block.id,
                          "field-name": "primaryButton"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(PrimaryButton, {
                              label: dataValues.value.primaryButton.data.label,
                              href: dataValues.value.primaryButton.data.href,
                              "background-color": styleValues.value.brand,
                              "text-color": styleValues.value.background,
                              class: "px-3.5 py-2.5 rounded-lg text-sm"
                            }, null, 8, ["label", "href", "background-color", "text-color"])
                          ]),
                          _: 1
                        }, 8, ["blockId"]))
                      : _createCommentVNode("", true),
                    (!dataValues.value.secondaryButton.isHidden)
                      ? (_openBlock(), _createBlock(EditableElement, {
                          key: 1,
                          blockId: _ctx.block.id,
                          "field-name": "secondaryButton"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(SecondaryButton, {
                              label: dataValues.value.secondaryButton.data.label,
                              href: dataValues.value.secondaryButton.data.href,
                              "text-color": styleValues.value.text,
                              class: "text-sm"
                            }, null, 8, ["label", "href", "text-color"])
                          ]),
                          _: 1
                        }, 8, ["blockId"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "backgroundColor", "scrollAnimationType"]))
}
}

})